<template>
    <div>
        <breadcrumbs-bar :breadcrumbs="breadcrumbs"/>

        <div class="page-help">
            <div class="page-help__title">
                <h1>{{ helpItemTitle }}</h1>
            </div>
            <div class="page-help__body">
                <div class="page-help__desc">
                    <div class="box-desc" v-html="helpItemContent"></div>
                </div>
            </div>
            <div class="page-help__bottom">
                <div class="container">
                    <h2>{{ $t('front.help.titles.need_more_help') }}</h2>
                    <v-btn @click="supportDialog = true">{{ $t('front.help.button.contact_us') }}</v-btn>
                </div>
            </div>
        </div>

        <v-dialog content-class="dialog-support" v-model="supportDialog" max-width="900px"
                  :persistent="isDialogPersistent">
            <support-popup @close="supportDialog = false" v-if="supportDialog"/>
        </v-dialog>
    </div>
</template>

<script>
import DialogSettings from "../../../../mixins/dialogSettings";
import apiData from "../../../../mixins/apiData";

export default {
    name: "HelpItemContent",

    mixins: [DialogSettings, apiData],

    data: function () {
        return {
            supportDialog: false,
        };
    },

    serverPrefetch() {
        return this.fetchData();
    },

    mounted() {
        this.fetchData();
    },

    computed: {
        helpItem() {
            let slug = this.$route.params.slug;

            for (let i = 0; i < this.$store.state.helpCategories.length; i++) {
                let item = this.$store.state.helpCategories[i].items.find(item => item.slug === slug);

                if (item) {
                    return item;
                }
            }

            return null;
        },

        helpItemTitle() {
            return this.helpItem && this.helpItem.question || '';
        },

        helpItemContent() {
            return this.helpItem && this.helpItem.answer || '';
        },

        categoryTitle() {
            return this.helpItem && this.helpItem.categoryTitle || '';
        },

        categoryLink() {
            return this.helpItem && this.helpItem.categoryPageUrl || '';
        },

        breadcrumbs() {
            let languageUrlPrefix = this.$store.getters.getLanguageUrlPrefix();

            return [
                {
                    text: this.$t('front.help.titles.help_center'),
                    disabled: false,
                    href: `${languageUrlPrefix}/help`,
                },
                {
                    text: this.categoryTitle,
                    disabled: false,
                    //href: `${languageUrlPrefix}${this.categoryLink}`,
                    href: this.categoryLink,
                },
                {
                    text: this.helpItemTitle,
                    disabled: false,
                    href: this.$route.path,
                },
            ];
        },
    },

    methods: {
        fetchData(){
            return this.$store.dispatch('FETCH_HELP_CATEGORIES', this.createApiData());
        },
    },
}
</script>

<style lang="sass">
@import "sass/components/pages/parts/target/HelpItemContent"
</style>